import moment from 'moment';
import T from '../../../common/components/T';
import Language from '../../../common/decorators/Language';
import { getData, navigateV2 } from '../../../common/utils/router';
import { getDefaultStaticProps, getLangPaths } from '../../api/_props';
import { API_SERVER_URL, useCategoriesData } from '../../../common/utils/utils';
import StoreRegisterView from '../../../views/storeregister/StoreRegister';
import Store from '../../../layouts/store/Store/Store';
import { getIsSponsor } from '../../../common/utils/memo';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import UserContext from '../../../common/utils/getContext';
const project = require('../../../scripts/configs/project.json');

const Register = ({ translates, categoriesData, categoriesMeta, redirect }) => {
    const { categories, loadMoreCategories } = useCategoriesData(categoriesData, categoriesMeta);
    const router = useRouter();
    const type = router?.query?.type[0];
    const { userToken, lang, storageLoaded, setState } = useContext(UserContext);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!['register'].includes(type)) {
            navigateV2('/error/404', true);
        } else if (storageLoaded && redirect) {
            document.location = redirect;
        } else {
            setLoading(false);
        }
    }, [userToken, storageLoaded, lang, type, redirect, router.query.type, setState]);

    if (loading) return null;

    return (
        <Language translates={translates} page='/store/register'>
            <Store
                title={<T textName='registration' defaultStr='Регистрация' />}
                categories={categories}
                loadMoreCategories={loadMoreCategories}
                translates={translates}
                officeBg={true}
                hideBeforeHeader={true}
            >
                <StoreRegisterView />
            </Store>
        </Language>
    );
};

export async function getStaticProps({ params }) {
    const lang = params.lang;

    if (params?.type?.[1] === 'ref' && params?.type[0] === 'register') {
        const dataValidReferalReq = params?.type?.[2] ? await getIsSponsor(null, params?.type?.[2]) : false;
        if (!dataValidReferalReq || dataValidReferalReq?.errors) {
            return {
                redirect: {
                    destination: '/error/refer',
                    permanent: false
                }
            };
        }
    } else if (params?.type?.[1] && params?.type?.[1] !== 'ref' && params?.type[0] !== 'register') {
        return {
            redirect: {
                destination: '/error/404',
                permanent: false
            }
        };
    }

    const defaultProps = await getDefaultStaticProps(
        lang,
        '/auth/register',
        ['/store', '/store/register', '/authentication', '/'],
        null,
        null,
        null,
        false,
        params?.type?.[2] || null
    );
    if (!defaultProps?.props) {
        return defaultProps;
    }
    const { currency } = defaultProps?.props;

    const categories = await getData(
        `${API_SERVER_URL}/api/v1/shop/product-categories?filter[parent_id]=0&page[size]=15&include=media`,
        false,
        lang,
        moment().format('1DD.ss.2MM.3mm'),
        currency
    );

    return {
        props: {
            ...defaultProps.props,
            categoriesData: categories?.data || [],
            categoriesMeta: { ...(categories?.meta || {}), ...(categories?.links || {}) }
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    let paths = [];
    const langs = await getLangPaths();
    const types = ['register'];
    langs.forEach((lang) => {
        types.forEach((type) => {
            paths.push({ ...lang, params: { ...lang.params, type: [type] } });
        });
    });
    return {
        paths,
        fallback: true
    };
}

export default Register;
